import { createConfig } from "@fideus/react-config";
import { configSchema } from "./Config";

export * from "./Config";
export * from "./testConfig";
export const {
  initConfig,
  getConfig,
  useConfig,
  ConfigProvider,
  TestConfigProvider,
} = createConfig({
  schema: configSchema,
  configPath: "/config.json",
  versionPath: "/version",
});
